import {useReportsModalContext} from 'modules/reports/components/Modal/ReportsModal.context'
import useMount from 'modules/reports/hooks/mount'
import React from 'react'
import useStyles from './ReportsModalExtension.styles'

type Props = {
  children: React.ReactNode
}

function ReportsModalExtension(props: Props) {
  const {setExtended} = useReportsModalContext()
  const classes = useStyles()

  useMount(() => {
    setExtended(true)

    return () => setExtended(false)
  })

  return <div className={classes.root}>{props.children}</div>
}

export default ReportsModalExtension
